import format from 'date-fns/format'
import ja from 'date-fns/locale/ja'
// 文字列関係のUtil
export default class DateUtil {
  static to_yyyymm_hyphen(date: Date) {
    return format(date, 'YYYY-MM')
  }

  static to_yyyym_ja(date: Date) {
    return format(date, 'YYYY年M月')
  }

  static to_yyyymmdd(date: Date) {
    return format(date, 'YYYYMMDD')
  }

  static to_yyyymmdd_slash(date: Date) {
    return format(date, 'YYYY/MM/DD')
  }
  static to_yyyymmdd_hyphen(date: Date) {
    return format(date, 'YYYY-MM-DD')
  }

  static to_yyyymmdd_ddd_slash(date: Date) {
    return format(date, 'YYYY/MM/DD(dd)', {locale: ja})
  }

  static to_yyyymmdd_hhmm_slash(date: Date) {
    return format(date, 'YYYY/MM/DD HH:mm')
  }

  static to_yyyymmdd_hhmmss_slash(date: Date) {
    return format(date, 'YYYY/MM/DD HH:mm:ss')
  }

}
